import dayjs from 'dayjs';

export enum IncidentStatus {
    OnGoing = 'Ongoing',
    Resolved = 'Resolved',
}

export enum Severity {
    P1 = 'P1',
    P2 = 'P2',
    P3 = 'P3',
}

export interface IncidentLog {
    text: string;
    timestamp: string;
    updatedBy?: string;
}

export interface Incident {
    id: string;
    description: string;
    startedAt: string;
    resolvedAt: string;
    reporter: string;
    service: string;
    status: IncidentStatus;
    severity: Severity;
    log: IncidentLog[];
}

interface SerializedIncident {
    id: string;
    description: string;
    startedAt: string;
    resolvedAt: string;
    reporter: string;
    service: string;
    status: string;
    severity: Severity;
    log: { text: string; timestamp: string; updatedBy?: string }[];
}

const DATE_FORMAT = 'DD-MM-YYYY HH:mm:ss';

export function deserializeIncident(data: SerializedIncident): Incident {
    return {
        id: data.id,
        description: data.description,
        startedAt: dayjs(data.startedAt).format(DATE_FORMAT),
        resolvedAt: dayjs(data.resolvedAt).format(DATE_FORMAT),
        reporter: data.reporter,
        service: data.service,
        status: data.status as IncidentStatus,
        severity: data.severity,
        log: data.log.map((l) => ({
            text: l.text,
            timestamp: dayjs(l.timestamp).format(DATE_FORMAT),
            updatedBy: l.updatedBy,
        })),
    };
}
